import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ClientsService } from '@app/shared/services/clients.service';
import { InventoryService } from '@app/shared/services/inventory.service';
import { SupplymaterialService } from '@app/shared/services/supplymaterial.service';

@Component({
  selector: 'app-supplyform',
  templateUrl: './supplyform.component.html',
  styleUrls: ['./supplyform.component.css']
})
export class SupplyformComponent implements OnInit {
  @Input() closePopup: Function; // Accept closePopup function as input

  addMaterialForm: FormGroup;
  subcategoryOptions: string[] = [];
  materialOptions: any[] = [];
  submaterialOptions: string[] = [];
  descriptionOptions: string[] = [];
  clientList: any[] = [];
  isUpdateMode: boolean = false;
  materialId: string;
  formData: any[] = [];
  users: any[] = [];
  currentPage: number = 1;
  itemsPerPage: number = 15;
  totalCount: number = 0;
  totalPages: number = 0;
  searchText: string = '';
  mathLib: any = Math;
  showTableView: boolean = false;
  filteredData: any[] = [];
  dateFilter: string = '';
  groupFilter: string = '';

  masterList: any[] = [];

  constructor(
    private fb: FormBuilder,
    private inventoryService: InventoryService,
    private clientService: ClientsService,
    private activatedRoute: ActivatedRoute,
    private materialService: SupplymaterialService
  ) {
    this.addMaterialForm = this.fb.group({
      deliveryDate: [new Date().toISOString().split('T')[0], Validators.required],
      sentTo: ['', Validators.required],
      group: ['', Validators.required],
      subgroup: ['', Validators.required],
      material: ['', Validators.required],
      submaterial: ['', Validators.required],
      description: ['', Validators.required],
      deliveryNo: ['', Validators.required],
      billNo: ['', Validators.required],
      amount1: ['', Validators.required],
      amount2: ['', Validators.required],
      location: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    // Initialize component properties and fetch initial data
    this.getClientList();
    this.getMasterMaterial();

    this.activatedRoute.params.subscribe(params => {
      const materialId = params['id'];
      if (materialId) {
        this.materialId = materialId;
        this.isUpdateMode = true;
        this.updateMaterail(this.materialId);
      }
    });
  }

  // Fetch the material by ID if in update mode
  updateMaterail(id: any) {
    this.materialService.getMaterialById(id).subscribe(
      (res: any) => {
        this.addMaterialForm.patchValue(res);
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  // Fetch all master materials for category and subgroup options
  getMasterMaterial() {
    this.inventoryService.getAllInventry().subscribe(
      (res: any) => {
        this.masterList = res;  // Store the full list of materials
        // Extract unique categories from the master list
        const uniqueCategories = [...new Set(this.masterList.map(item => item.category))];
        this.materialOptions = uniqueCategories;  // Populate category options
      },
      (err: any) => {
        console.error('Error fetching categories:', err);
      }
    );
  }

  // When the group (category) changes, filter the subgroups accordingly
  updateSubcategories(selectedCategory: string) {
  const selectedCategoryData = this.masterList.filter(item => item.category === selectedCategory);
  
  // Extract subcategories for the selected category
  this.subcategoryOptions = [...new Set(selectedCategoryData.map(item => item.subcategory))];

  // If you want to reset the subcategory field when a category changes, you can set it to an empty string
  this.addMaterialForm.get('subgroup')?.setValue('');
}




  // Add or update material in the inventory
  addMaterial(): void {
    if (this.addMaterialForm.valid) {
      const formData = this.addMaterialForm.value;
      if (this.isUpdateMode && this.materialId) {
        this.materialService.updateMaterial(this.materialId, formData).subscribe(
          (res: any) => {
            console.log(res);
            this.addMaterialForm.reset();
          },
          (err: any) => {
            console.log(err);
          }
        );
      } else {
        this.materialService.addMaterial(formData).subscribe(
          (res: any) => {
            console.log(res);
            this.addMaterialForm.reset();
          },
          (err: any) => {
            console.log(err);
          }
        );
      }
    }
  }

  // Close the popup
  onClose(): void {
    if (this.closePopup) {
      this.closePopup();
    }
  }

  // Fetch the client list
  getClientList() {
    this.clientService.getClientList().subscribe(
      (res: any) => {
        this.clientList = res;
      },
      (err: any) => {
        console.log(err);
      }
    );
  }
}
